
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/55e89e1ddaf40cde2e2726818812427e.jpg"
              alt="DUO FORM Company"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              About DUO FORM
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              DUO FORM, s.r.o. is a leading technology company based in Skalica, Slovakia, dedicated to developing innovative security solutions that protect users' digital privacy and enhance their online experience.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our flagship VPN application represents years of research and development in cybersecurity technology, combining cutting-edge encryption protocols with user-friendly design to deliver a seamless and secure internet experience for users worldwide.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              We believe that online privacy is a fundamental right, and our mission is to make advanced security technology accessible to everyone through our reliable, fast, and easy-to-use VPN solution that protects your digital footprint.
            </p>
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-indigo-600 mb-2">100+</div>
                <div className="text-gray-600">Server Locations</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-indigo-600 mb-2">256-bit</div>
                <div className="text-gray-600">Encryption</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-indigo-600 mb-2">24/7</div>
                <div className="text-gray-600">Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
